export default "__VITE_ASSET__fd35dc34__"